import React from 'react'
import cn from 'classnames'

type PromoBannerProps = {
  // Pre-rendered banner copy (caller resolves styled/GrowthBook text)
  text: React.ReactNode
  // Pre-rendered urgency, shown small/tinted after the text (stacked on mobile,
  // baseline-aligned beside the text on desktop)
  urgencyText?: React.ReactNode
  // Overrides the default `bg-c-base-300` container background
  containerClassName?: string
  // Overrides the default text styling
  textClassName?: string
  cta: React.ReactNode
  ctaClassNames?: string
}

export const PromoBanner = ({
  text,
  urgencyText,
  containerClassName,
  textClassName,
  cta,
  ctaClassNames,
}: PromoBannerProps) => (
  <div
    className={cn(
      containerClassName ?? 'bg-c-base-300',
      'flex items-center justify-between md:justify-center py-3 mc-text-small text-c-text-dark px-6',
    )}
  >
    <div className='flex flex-col md:flex-row md:items-baseline'>
      <div
        className={
          textClassName ?? 'c-banner-heading text-c-text-dark m-0 text-balance'
        }
      >
        {text}
      </div>
      {urgencyText && (
        <span className='c-body-small md:c-body text-c-text-tint-2 ml-0 md:ml-2'>
          {urgencyText}
        </span>
      )}
    </div>
    <div
      className={cn({
        'ml-3': !ctaClassNames,
        [ctaClassNames || '']: !!ctaClassNames,
      })}
    >
      {cta}
    </div>
  </div>
)
